var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBootsInfoGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM8.63574 11H7.36328V7H8.63574V11ZM8 5C8.35129 5.00019 8.63574 5.28538 8.63574 5.63672C8.63555 5.98789 8.35117 6.27227 8 6.27246C7.64866 6.27246 7.36347 5.98801 7.36328 5.63672C7.36328 5.28526 7.64855 5 8 5Z",
    fill: "#33333F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootsInfoGrey);
export default __webpack_public_path__ + "static/media/boots-info-grey.41854d15babd88407ca6edc930a5c28e.svg";
export { ForwardRef as ReactComponent };